import { Grid, Radio } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { getSteelReconciliation, getSteelReconciliationById, setInitSteelReconciliationDataById } from "../../redux/reducers/inventorySlice";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import "./Reports.scss";
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    PointElement,
    LineElement,
    LineController,
} from "chart.js";
import { CHART_COLORS, customTooltip } from "../../constants/reactChartConstants";
import { getSteelConsumption, getSteelConsumptionById } from "../../redux/reducers/pilesReducers";

ChartJS.register(
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    PointElement,
    LineElement,
    LineController
);

const steelDias = ["8 mm", "10 mm", "12 mm", "16 mm", "20 mm", "25 mm", "32 mm", "36 mm"]

const SteelReconciliationBar = () => {

    const dispatch = useDispatch<AppDispatch>();
    const allProjectData = useSelector(
        (state: any) => state.PROJECT.allProjectData
    );
    //--to get current details
    useEffect(() => {
        dispatch(setInitSteelReconciliationDataById());

    }, [dispatch]);
    const steelReconciliationData = useSelector((state: any) => state.INVENTORY.steelReconciliationData);
    const steelReconciliationDataById2 = useSelector((state: any) => state.INVENTORY.steelReconciliationDataById);
    const steelConsumptionData = useSelector((state: any) => state.PILES.steelConsumption);
    const steelConsumptionDataProjectwise = useSelector((state: any) => state.PILES.steelConsumptionById);
    const [projectList, setProjectList] = useState([]);
    const [consumedData, setConsumedData] = useState([]);
    const [projectId2, setProjectId2] = useState("");
    const [projectName2, setProjectName2] = useState("");
    const [value, setValue] = useState({ from: "", to: "" });
    const [isOverallBar, setIsOverallBar] = useState(true);
    const handleFilterDate = () => {
      if (value.to && value.from) {
        setConsumedData([])
        if (projectId2 === "") {
          dispatch(
            getSteelConsumption({
              endPoint: `piles/steel-consumption?to=${value.to}&from=${value.from}`,
            })
          );
          dispatch(
            getSteelReconciliation({
              endPoint: `inventory/get-overall-steel-reconciliation?to=${value.to}&from=${value.from}`,
            })
          );
        } else {
          dispatch(
            getSteelConsumptionById({
              endPoint: `piles/steel-consumption/?projectId=${projectId2}&to=${value.to}&from=${value.from}`,
            })
          );
          dispatch(
            getSteelReconciliationById({
              endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId2}&to=${value.to}&from=${value.from}`,
            })
          );
        }
      }
    };
    const resetToAll = () => {
      setValue({ from: "", to: "" });
      setConsumedData([])
        if (projectId2 === "") {
          dispatch(
            getSteelConsumption({
              endPoint: `piles/steel-consumption`,
            })
          );
          dispatch(
            getSteelReconciliation({
              endPoint: `inventory/get-overall-steel-reconciliation`,
            })
          );
        } else {
          dispatch(
            getSteelConsumptionById({
              endPoint: `piles/steel-consumption/?projectId=${projectId2}`,
            })
          );
          dispatch(
            getSteelReconciliationById({
              endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId2}`,
            })
          );
        }
    };

    useEffect(() => {
        dispatch(
            getAllProjectData({
                endPoint: `project/get-all-projects`,
            })
        );
    }, [dispatch]);

    useEffect(() => {
        if (projectId2 !== "") {
            dispatch(
                getSteelConsumptionById({
                    endPoint: `piles/steel-consumption/?projectId=${projectId2}`
                })
            );
            
        }
        else {
            dispatch(
                getSteelConsumption({
                    endPoint: `piles/steel-consumption`,
                })
            );
            
        }
    }, [dispatch, projectId2])

    useEffect(() => {
        if (allProjectData) {
            setProjectList(() => allProjectData.map((val: any) => val._id));
        }
    }, [projectList, allProjectData]);

    useEffect(() => {
        if (projectId2 !== "") {
            dispatch(
                getSteelReconciliationById({
                    endPoint: `inventory/get-steel-reconciliation-byId/?projectId=${projectId2}`
                })
            );
        }
        else dispatch(
            getSteelReconciliation({
                endPoint: `inventory/get-overall-steel-reconciliation`,
            })
        );

    }, [dispatch, projectId2])

    useEffect(()=>{
        if(projectId2!==""){
            if (steelConsumptionDataProjectwise?.length > 0) {
                const consumedSteelData = steelConsumptionDataProjectwise?.filter((item:any)=>item?.pileStatus==="completed"||item.pileStatus==="completed with delay")?.map((val: any) => ({
                    id: val?._id,
                    pileId: val?.pileId,
                    "8 mm": (val?.reinforcement[0]?.type === 8) ? (val?.reinforcement[0]?.count) : "0",
                    "10 mm": (val?.reinforcement[0]?.type !== 10) ? (val?.reinforcement[1]?.type === 10) ? (val?.reinforcement[1]?.count) : "0" : (val?.reinforcement[0]?.count),
                    "12 mm": (val?.reinforcement[0]?.type !== 12) ? (val?.reinforcement[1]?.type !== 12) ? (val?.reinforcement[2]?.type === 12) ? (val?.reinforcement[2]?.count) : "0"
                        : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "16 mm": (val?.reinforcement[0]?.type !== 16) ? (val?.reinforcement[1]?.type !== 16) ? (val?.reinforcement[2]?.type !== 16) ? (val?.reinforcement[3]?.type === 16) ? (val?.reinforcement[3]?.count) : "0"
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "20 mm": (val?.reinforcement[0]?.type !== 20) ? (val?.reinforcement[1]?.type !== 20) ? (val?.reinforcement[2]?.type !== 20) ? (val?.reinforcement[3]?.type !== 20) ? (val?.reinforcement[4]?.type === 20)
                        ? (val?.reinforcement[4]?.count) : "0" : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "25 mm": (val?.reinforcement[0]?.type !== 25) ? (val?.reinforcement[1]?.type !== 25) ? (val?.reinforcement[2]?.type !== 25) ? (val?.reinforcement[3]?.type !== 25) ? (val?.reinforcement[4]?.type !== 25) ?
                        (val?.reinforcement[5]?.type === 25) ? (val?.reinforcement[5]?.count) : "0" : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "32 mm": (val?.reinforcement[0]?.type !== 32) ? (val?.reinforcement[1]?.type !== 32) ? (val?.reinforcement[2]?.type !== 32) ? (val?.reinforcement[3]?.type !== 32) ? (val?.reinforcement[4]?.type !== 32) ?
                        (val?.reinforcement[5]?.type !== 32) ? (val?.reinforcement[6]?.type === 32) ? (val?.reinforcement[6]?.count) : "0" : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "36 mm": (val?.reinforcement[0]?.type !== 36) ? (val?.reinforcement[1]?.type !== 36) ? (val?.reinforcement[2]?.type !== 36) ? (val?.reinforcement[3]?.type !== 36) ? (val?.reinforcement[4]?.type !== 36) ?
                        (val?.reinforcement[5]?.type !== 36) ? (val?.reinforcement[6]?.type !== 36) ? (val?.reinforcement[7]?.type === 36) ? (val?.reinforcement[7]?.count) : "0" : (val?.reinforcement[6]?.count)
                            : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                        : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),

                    "total": val?.total.toFixed(3)

                }));
                const totalConsumedData:any = steelDias.map((steelDia: any) => {
                    return consumedSteelData
                      .map((item: any) => {
                        // console.log(item[steelDia]);
                        return item[steelDia];
                      })
                      .reduce((preVal: any, currVal: any) => {
                        // console.log(preVal, currVal);
                        return preVal + parseInt(currVal);
                      }, 0);
                    });
                setConsumedData(totalConsumedData)
            }
        }else{
            if(steelConsumptionData.length>0){
                const consumedSteelData = steelConsumptionData.filter((item:any)=>item?.pileStatus==="completed"||item.pileStatus==="completed with delay")?.map((val:any)=>({
                    id: val?._id,
                        pileId: val?.pileId,
                        "8 mm": (val?.reinforcement[0]?.type === 8) ? (val?.reinforcement[0]?.count) : "0",
                        "10 mm": (val?.reinforcement[0]?.type !== 10) ? (val?.reinforcement[1]?.type === 10) ? (val?.reinforcement[1]?.count) : "0" : (val?.reinforcement[0]?.count),
                        "12 mm": (val?.reinforcement[0]?.type !== 12) ? (val?.reinforcement[1]?.type !== 12) ? (val?.reinforcement[2]?.type === 12) ? (val?.reinforcement[2]?.count) : "0"
                            : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "16 mm": (val?.reinforcement[0]?.type !== 16) ? (val?.reinforcement[1]?.type !== 16) ? (val?.reinforcement[2]?.type !== 16) ? (val?.reinforcement[3]?.type === 16) ? (val?.reinforcement[3]?.count) : "0"
                            : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "20 mm": (val?.reinforcement[0]?.type !== 20) ? (val?.reinforcement[1]?.type !== 20) ? (val?.reinforcement[2]?.type !== 20) ? (val?.reinforcement[3]?.type !== 20) ? (val?.reinforcement[4]?.type === 20)
                            ? (val?.reinforcement[4]?.count) : "0" : (val?.reinforcement[3]?.count)
                            : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "25 mm": (val?.reinforcement[0]?.type !== 25) ? (val?.reinforcement[1]?.type !== 25) ? (val?.reinforcement[2]?.type !== 25) ? (val?.reinforcement[3]?.type !== 25) ? (val?.reinforcement[4]?.type !== 25) ?
                            (val?.reinforcement[5]?.type === 25) ? (val?.reinforcement[5]?.count) : "0" : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                            : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "32 mm": (val?.reinforcement[0]?.type !== 32) ? (val?.reinforcement[1]?.type !== 32) ? (val?.reinforcement[2]?.type !== 32) ? (val?.reinforcement[3]?.type !== 32) ? (val?.reinforcement[4]?.type !== 32) ?
                            (val?.reinforcement[5]?.type !== 32) ? (val?.reinforcement[6]?.type === 32) ? (val?.reinforcement[6]?.count) : "0" : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                            : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "36 mm": (val?.reinforcement[0]?.type !== 36) ? (val?.reinforcement[1]?.type !== 36) ? (val?.reinforcement[2]?.type !== 36) ? (val?.reinforcement[3]?.type !== 36) ? (val?.reinforcement[4]?.type !== 36) ?
                            (val?.reinforcement[5]?.type !== 36) ? (val?.reinforcement[6]?.type !== 36) ? (val?.reinforcement[7]?.type === 36) ? (val?.reinforcement[7]?.count) : "0" : (val?.reinforcement[6]?.count)
                                : (val?.reinforcement[5]?.count) : (val?.reinforcement[4]?.count) : (val?.reinforcement[3]?.count)
                            : (val?.reinforcement[2]?.count) : (val?.reinforcement[1]?.count) : (val?.reinforcement[0]?.count),
    
                        "total": val?.total.toFixed(3)
                }))
                const totalConsumedData:any = steelDias.map((steelDia: any) => {
                    return consumedSteelData
                      .map((item: any) => {
                        // console.log(item[steelDia]);
                        return item[steelDia];
                      })
                      .reduce((preVal: any, currVal: any) => {
                        // console.log(preVal, currVal);
                        return preVal + parseInt(currVal);
                      }, 0);
                    });
                setConsumedData(totalConsumedData)
            }
            
        }
    },[projectId2, steelConsumptionData, steelConsumptionDataProjectwise])
    // console.log(consumedData)
    const projectsData: [] =
        allProjectData &&
        allProjectData?.map((item: any) => {
            return item?.projectName;
        });

    const changeReset = () => { };

    //-------bar chart data------------
    const barChartData: any = {
        labels: ["8 mm", "10 mm", "12 mm", "16 mm", "20 mm", "25 mm", "32 mm", "36 mm"],
        datasets: [
            {
                label: "Received",
                data: [(steelReconciliationData.length > 0 && steelReconciliationData[0].length > 0) ? steelReconciliationData[0][0].received : 0,
                (steelReconciliationData.length > 1 && steelReconciliationData[1].length > 0) ? steelReconciliationData[1][0].received : 0,
                (steelReconciliationData.length > 2 && steelReconciliationData[2].length > 0) ? steelReconciliationData[2][0].received : 0,
                (steelReconciliationData.length > 3 && steelReconciliationData[3].length > 0) ? steelReconciliationData[3][0].received : 0,
                (steelReconciliationData.length > 4 && steelReconciliationData[4].length > 0) ? steelReconciliationData[4][0].received : 0,
                (steelReconciliationData.length > 5 && steelReconciliationData[5].length > 0) ? steelReconciliationData[5][0].received : 0,
                (steelReconciliationData.length > 6 && steelReconciliationData[6].length > 0) ? steelReconciliationData[6][0].received : 0,
                (steelReconciliationData.length > 7 && steelReconciliationData[7].length > 0) ? steelReconciliationData[7][0].received : 0,
                ],
                backgroundColor: [CHART_COLORS.BLUE],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE]
            },
            {
                label: "Consumed",
                data: consumedData,
                backgroundColor: [CHART_COLORS.YELLOW],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW]
            }
        ],
    };

    //-----for projectwise------------
    const barChartData2: any = {
        labels: ["8 mm", "10 mm", "12 mm", "16 mm", "20 mm", "25 mm", "32 mm", "36 mm"],
        datasets: [
            {
                label: "Received",
                data: [(steelReconciliationDataById2.length > 0 && steelReconciliationDataById2[0].length > 0) ? steelReconciliationDataById2[0][0].received : 0,
                (steelReconciliationDataById2.length > 1 && steelReconciliationDataById2[1].length > 0) ? steelReconciliationDataById2[1][0].received : 0,
                (steelReconciliationDataById2.length > 2 && steelReconciliationDataById2[2].length > 0) ? steelReconciliationDataById2[2][0].received : 0,
                (steelReconciliationDataById2.length > 3 && steelReconciliationDataById2[3].length > 0) ? steelReconciliationDataById2[3][0].received : 0,
                (steelReconciliationDataById2.length > 4 && steelReconciliationDataById2[4].length > 0) ? steelReconciliationDataById2[4][0].received : 0,
                (steelReconciliationDataById2.length > 5 && steelReconciliationDataById2[5].length > 0) ? steelReconciliationDataById2[5][0].received : 0,
                (steelReconciliationDataById2.length > 6 && steelReconciliationDataById2[6].length > 0) ? steelReconciliationDataById2[6][0].received : 0,
                (steelReconciliationDataById2.length > 7 && steelReconciliationDataById2[7].length > 0) ? steelReconciliationDataById2[7][0].received : 0,
                ],
                backgroundColor: [CHART_COLORS.BLUE],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE]
            },
            {
                label: "Consumed",
                data: consumedData,
                backgroundColor: [CHART_COLORS.YELLOW],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW]
            }
        ],
    };
    const steelConsumptionBarOptions: any = {
        plugins: {
            tooltip: customTooltip
        },
        maintainAspectRatio: false,
        scales: {
            y: { title: { display: true, text: 'Quantity of Steel (MT)', font: { weight: 'bold' } } },
            x: { title: { display: true, text: 'Steel Diameter (mm)', font: { weight: 'bold' } } },
        }
    }

    return (
        <Grid container className="mt0 pt1">
            <Grid item xs={12} container className="bg--white box--shadow mt0 plr-1">
                <Grid item xs={12} className="mb2">
                    <Grid className="d-flex">
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt1"
                        >
                            <span className="fw500">Steel Reconciliation Report</span>
                        </Text>
                    </Grid>

                    <Grid xs={12} className="d-flex mt1">
                        <Grid className="radio_box">
                            <Radio
                                checked={
                                    isOverallBar
                                }
                                onChange={(e) => {
                                    setIsOverallBar(true);
                                    setProjectName2('');
                                    setProjectId2('');
                                }}
                                value="mandatory"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Mandatory" }}
                                color="primary"
                            />
                            <label>Overall</label>
                            <Radio
                                checked={
                                    !isOverallBar
                                }
                                onChange={(e) => {
                                    setIsOverallBar(false);
                                }}
                                value="optional"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Optional" }}
                                color="primary"
                            />
                            <label>Project-Wise</label>
                        </Grid>

                        <Grid item className={"mt ml-1"}
                            direction="row"
                            alignItems="center">
                            <div className="filter_box_ml">
                                <FilterComponent
                                    handleFilterDate={handleFilterDate}
                                    setValue={setValue}
                                    value={value}
                                    resetAll={resetToAll}
                                />
                            </div>
                        </Grid>
                        <Grid item className="mt2 ml-1">
                            <Button
                                type="button"
                                size="medium"
                                isRounded={true}
                                category="primary"
                                onClick={() => {
                                }}
                                className="submit_button mt mr-1 pl pr f14"
                            >
                                <SVG type={"searchIcon"} />
                                Search
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} className="d-flex" >
                        {!isOverallBar && <Grid item xs={3}>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                                <span className="fw500">Select Project</span>
                            </Text>
                            <SelectBox
                                data={projectsData ? projectsData : DATA_NOT_FOUND}
                                placeHolder="Select Project"
                                borderColor={"primary"}
                                defaultValue={projectName2}
                                changeReset={changeReset}
                                onChange={(e: any) => {
                                    setProjectName2(e.target.value);
                                    const index = projectsData
                                        ?.map((item: any) => item)
                                        .indexOf(e.target.value);
                                    setProjectId2(
                                        allProjectData && allProjectData[index]?._id
                                    );
                                }}
                            />
                        </Grid>}

                    </Grid>
                </Grid>

                {(!isOverallBar && projectName2 === "") ? (
                    <>
                        <Grid xs={12}>
                            <SelectOptionMsg text={`Select project to view Project information`} /> </Grid></>) : (
                    <>
                        <Grid item xs={11} style={{ height: 300 }}  >
                            <Bar className="mt1" data={(projectName2 === "") ? barChartData : barChartData2}
                                options={steelConsumptionBarOptions} />
                        </Grid>
                    </>)}
            </Grid>
        </Grid>
    )
}

export default SteelReconciliationBar;